import { createPromiseClient } from '@bufbuild/connect-web';
import { AccountManager } from '@/generated/msh/service/v1/account_manager_connectweb';
import { AcceptUserInvitationRequest } from '@/generated/msh/service/v1/account_manager_pb';
import { transport } from '../transport';

const client = createPromiseClient(AccountManager, transport);

export async function acceptInvitation(
    { user_invitation_id, name, email, lang, phone, password, avatar},
    signal
) {
  const response = await client.acceptUserInvitation(
    new AcceptUserInvitationRequest(
        {
            userInvitationId: user_invitation_id,
            name: name,
            email: email,
            lang: lang,
            phone: phone,
            password: password,
            avatar: avatar
     }),
     { signal }
  );
  return;
}
